import { render, staticRenderFns } from "./detailmap.vue?vue&type=template&id=1f82abfd&"
import script from "./detailmap.vue?vue&type=script&lang=js&"
export * from "./detailmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports